module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_inhouse-c931735d399cd7f8de4cda276a15e79f.svg";